module.exports = __webpack_public_path__ + "img/icon-jujue.1c9c0dab.png";